import { RouteRecordRaw } from "vue-router";

const routes: RouteRecordRaw[] = [
  {
    path: "",
    component: () => import("../pages/GMC.vue"),
    children: [
      {
        path: "change_model",
        component: () => import("../pages/GMCChangeModel.vue"),
      },
      {
        path: "training",
        component: () => import("../pages/GMCTraining.vue"),
      },
      {
        path: "training-kaldi",
        component: () => import("../pages/GMCTrainingKaldi.vue"),
      },
      {
        path: "testing",
        component: () => import("../pages/GMCTesting.vue"),
      },
    ],
  },
];

export default routes;
